<template>
  <div class="message-window-2">
    <v-layout row class="justify-space-between align-center mt-1">
      <div class="display-1 mx-2">Messages du bien</div>
      <v-flex xs2 class="d-flex d-flex-initial justify-end pr-3">
        <v-icon color="accent" size="24" @click="hideFloatingWindows"
          >close</v-icon
        >
      </v-flex>
    </v-layout>

    <div class="mx-2">
      <div
        v-for="(com, id) in sortedComments"
        :key="id"
        :class="{
          'ml-3': com.owner === 'user',
          'mr-3': com.owner === 'hil',
          'mr-2': true,
          'pb-2': true
        }"
      >
        <!-- Prettier rule: https://prettier.io/blog/2018/11/07/1.15.0.html#whitespace-sensitive-formatting -->
        <!-- display: inline -->
        <div
          class="message-content px-2 py-2 mt-3"
          :class="{ [`comm-${com.owner}`]: true }"
          >{{ com.comment }}</div
        >
        <div class="message-infos d-flex justify-content-between">
          {{ com.name || "???" }} &mdash; {{ com.date | fullDate }}
          <div class="ml-2">
            <a style="color:red" @click="$emit('removeComment', com.idx)"
              >Supprimer</a
            >
          </div>
        </div>
      </div>
      <v-layout row align-baseline justify-center class="pl-3 pr-2">
        <v-flex>
          <v-textarea label="Message" rows="3" v-model="message"></v-textarea>
        </v-flex>
        <v-flex xs1>
          <v-icon style="cursor:pointer;" @click="sendMessage">send</v-icon>
        </v-flex>
      </v-layout>
    </div>
    <v-snackbar v-model="showError">
      Une erreur a eu lieu
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { fetchHil } from "../../utils";
import { mapActions, mapState } from "vuex";
export default {
  props: ["proposal"],
  data() {
    return {
      message: "",
      showError: false
    };
  },
  mounted() {
    this.markNotifsAsRead({
      projectId: this.proposal.idBuy,
      estateId: this.proposal.idSell
    });
    this.goDown();
  },
  methods: {
    ...mapActions("notifications", ["markNotifsAsRead"]),

    async sendMessage() {
      if (this.message == null) {
        return;
      }
      this.$emit("pushComment", {
        comment: this.message,
        name: this.id,
        date: new Date(),
        owner: "hil"
      });
      this.message = "";
      this.goDown();
    },
    color(comm) {
      switch (comm.owner) {
        case "hil":
          return "#60A694";
        case "user":
          return "#FF7C5D";
        default:
          return "#DDD";
      }
    },
    goDown() {
      let container = this.$el;
      container.scrollTop = container.scrollHeight;
    },
    hideFloatingWindows() {
      window.document.body.classList.remove("display-floating-window");
    }
  },
  computed: {
    ...mapState("user", ["id"]),
    sortedComments() {
      let comms = [];
      if (this.proposal.comments != null) {
        comms = [
          ...(this.proposal.comments.map((c, idx) => ({ ...c, idx })) || [])
        ];
      }
      comms.sort((a, b) => {
        return moment(b.date).isAfter(a.date) ? 1 : -1;
      });
      return comms;
    }
  }
};
</script>
<style>
.message-window-2 {
  height: calc(100vh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
